import numeral from 'numeral'
import Swal from 'sweetalert2'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { ShowBusy } from '../Reducers/InicioReducer'
import { CancelarOrdenAsync, OrdenesActivasAsync } from '../Servicios/ServiciosPublicos'
import { OrdenRender } from '../Controles/OrdenRender'
import { NoOrdenRender } from '../Controles/NoOrdenRender'


export const OrdenesActivasRender = (params) => {

    const dispatch = useDispatch()
    const [internalState, setInternalState] = useState({
        OrdenesActivas: []
    })

    useEffect(() => {
        ObtenerOrdenesActivas();
    }, [])

    const ObtenerOrdenesActivas = async () => {
        dispatch(ShowBusy());
        let _ordenesActivas = await OrdenesActivasAsync({ Moneda: params.MonedaDetalle.Item.Clave });
        dispatch(ShowBusy(false));
        setInternalState((state) => ({ ...state, OrdenesActivas: _ordenesActivas.Detalle }));
    }

    return (
        <div className="tab-bitso">
            {internalState.OrdenesActivas.map((item, i) => (<OrdenRender Item={item} ObtenerOrdenesActivas={ObtenerOrdenesActivas} />))}
            {internalState.OrdenesActivas.length === 0 && (<NoOrdenRender />)}
        </div>
    )
}
